import start from '../../../../common/microservices/loaders/sync'

import '../lazy-microservices/lazy-microservices'

start(() => import('./render'), 'microservice__prices-table__root', {
  lazyStoreManagerLoader: () => import('../../../../common/microservices/lazy-store-manager'),
})
